module.exports = __webpack_public_path__ + "img/our-platform-bg.c6f38f03.png";